import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductData } from 'types/ProductData';
import { Card } from 'ui/Card';
import DefaultPagination from 'public/components/DefaultLayout/DefaultPagination';
import { options } from 'config/config';

const DEFAULT_IMAGE = options.images.defaultProductImage;

interface FarmProductsProps {
  farmName?: string;
  products?: ProductData[];
  total?: number;
  pageSize?: number;
  currentPage?: number;
  onPageChange: (page: number) => void;
}

const FarmProducts = ({
  farmName,
  products,
  total = 0,
  pageSize = 0,
  currentPage = 1,
  onPageChange,
}: FarmProductsProps) => {
  const sectionRef = useRef<HTMLElement>(null);

  if (!products?.length) return null;

  const handlePageChange = (page: number) => {
    onPageChange(page);
    sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className={'farm-products'} ref={sectionRef}>
      <div className={'container'}>
        <h2 className={'farm-products-title'}>
          <FormattedMessage
            id={'product_view.farm_production'}
            values={{ farm: <strong>{farmName}</strong> }}
          />
        </h2>
        <div className={'farm-products-grid'}>
          {products.map((product) => (
            <Card
              key={product.id}
              product={product}
              hoverable
              farmView
              imageUrl={
                product.image_small || product.farm?.logo || DEFAULT_IMAGE
              }
            />
          ))}
        </div>
        {!!pageSize && total > pageSize && (
          <DefaultPagination
            totalRecords={total}
            pageSize={pageSize}
            currentPage={currentPage}
            onChange={handlePageChange}
          />
        )}
      </div>
    </section>
  );
};

export default FarmProducts;
